import * as React from 'react';
import DoublePanel from '../../../components/common/DoublePanel/DoublePanel';
import SearchInput from '../../../components/common/SearchInput';
import Details from './Details';
import moment from 'moment';
import DatePicker from '../../../components/common/DatePicker';
import Select from 'react-select';
import axios from 'axios'
import AxiosConfig from '../../../utilities/AxiosConfig';
import { connect } from 'react-redux';
import { AppState } from '../../../store';
import { DepartmentReferenceType } from './types';
import { CSVLink } from "react-csv";
import CsvIcon from '../../../media/CsvIcon.png';
import dayjs from 'dayjs';
import { addFavoriteFilter } from '../../../store/user/actions';
import { getSavedFilter, useQuery } from '../../../utilities/helper';

export interface IProps {
    profitCenterId: any;
    addFavoriteFilter: any;
    history: any;
}
const daysOfWeek: any = ["Saturday", "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday"]

const TimeAdministration: React.FC<IProps> = (props: IProps) => {
    const tableRef: any = React.useRef();
    const [data, setData] = React.useState([] as Array<any>);
    const [showZeros, setShowZeros] = React.useState(false);
    const [fromToDate, setFromToDate] = React.useState({ from: "", to: "" } as any);
    const [reference, setReference] = React.useState(null as any);
    const [state, setState] = React.useState(null as any);
    const [profitCenter, setProfitCenter] = React.useState(null as any);
    const [inUsePC, setInUsePC] = React.useState(null as any);
    const [selected, setSelected] = React.useState([-1, -1]);
    const CSVRef: any = React.useRef([] as Array<any>);
    const query: any = useQuery();
    let cancelTokenSource: any = React.useRef(null as any);

    const cellFormatter: any = (cell: any, row: any, rowIndex: number, extraData: any, colIndex: number) => {
        const total: number = cell.entries ? cell.entries.reduce((acc: number, entry: any) => entry.IsOutOfPC ? acc : entry.Category?.includes("Lunch") ? acc : entry.Quantity + acc, 0) : 0;
        let notApproved: number = 0;
        let isDisputed: number = 0;
        let outOfPC: boolean = false;
        //cgm070622 =>> checking for 
        let entries = cell.entries;
        for (let i = 0; i < entries.length; i++) {
            if (!entries[i].IsApproved && entries[i].TimeEntryId > 0 && profitCenter.value === entries[i].ProfitCenterId) {
                notApproved++
            }
            if (entries[i].IsDisputed && profitCenter.value === entries[i].ProfitCenterId) {
                isDisputed++
            }
            //r-18-lint-dj
            // eslint-disable-next-line
            if (entries[i].IsOutOfPC) { outOfPC = true; }
        }

        return <span
            onClick={(e: any) => handleCellClick(e, {
                entries: cell.entries,
                employeeId: row.EmployeeId,
                employee: row.Employee,
                date: moment(cell.date).valueOf(),
                inUsePC
            }, rowIndex, colIndex)}
            className={`action-text p-2 ${isDisputed > 0 && "border border-danger"} ${notApproved > 0 ? "text-danger" : total <= 0 ? "text-secondary" : "text-success"} `}
        >
            {extraData.showZeros ? total.toFixed(2) : total > 0 ? total.toFixed(2) : "-"}
        </span>;
    }

    const expandedRow: any = {
        renderer: (row: any, extraData: any) => {
            const { Sunday, Saturday, Monday, Tuesday, Wednesday, Thursday, Friday } = row;
            //console.log("ROW", row);
            const weekData: any = [
                ...Saturday.entries,
                ...Sunday.entries,
                ...Monday.entries,
                ...Tuesday.entries,
                ...Wednesday.entries,
                ...Thursday.entries,
                ...Friday.entries
            ];
            let categories: any = {};
            //r-18-lint-dj
            // eslint-disable-next-line
            weekData.map((entry: any) => {
                let departmentName: string | undefined = reference.departments.find((dept: DepartmentReferenceType) => dept.DepartmentId === entry.DepartmentId)?.Description;
                if (!departmentName) { departmentName = entry.DepartmentId; }
                if (!categories[entry.Category] && entry.TimeEntryId > 0) {
                    categories[`${entry.Category} (${entry.DepartmentId})`] = {
                        category: entry.Category,
                        departmentId: entry.DepartmentId,
                        departmentName
                    };
                }
            })
            //@ts-ignore
            const tableHeaders: any = document.querySelectorAll("#time-admin-table thead tr th");
            let width: number = 150;
            let endWidth: number = 150;
            if (tableHeaders) {
                width = 0;
                width += tableHeaders[0]?.offsetWidth;
                width += tableHeaders[1]?.offsetWidth;
                endWidth = 0;
                endWidth += tableHeaders[tableHeaders.length - 1]?.offsetWidth;
                endWidth += tableHeaders[tableHeaders.length - 2]?.offsetWidth;
            }
            return <div style={{ marginRight: endWidth }}>
                <table className="table p-0 time-admin-nested" style={{ marginRight: endWidth - 34 }}>
                    <thead>
                        <tr>
                            <th></th>
                            <th>SAT</th>
                            <th>SUN</th>
                            <th>MON</th>
                            <th>TUE</th>
                            <th>WED</th>
                            <th>THU</th>
                            <th>FRI</th>
                        </tr>
                    </thead>
                    <tbody className="time-admin-nested">
                        {
                            Object.keys(categories).map((key: string) => {
                                return (
                                    <tr key={key} className="time-admin-nested">
                                        <td style={{ width: width - 14 }}><div >{categories[key].category}({categories[key].departmentName})</div></td>
                                        {daysOfWeek.map((day: string) =>
                                            <td key={day}>
                                                {/* Here be ye zeros, matey! */}
                                                {
                                                    showZeros ?
                                                        row[day]?.entries
                                                            .filter((entry: any) => entry.Category === categories[key].category && entry.DepartmentId === categories[key].departmentId)
                                                            .reduce((acc: number, cur: any) => acc + cur.Quantity, 0).toFixed(2)
                                                        :
                                                        row[day]?.entries
                                                            .filter((entry: any) => entry.Category === categories[key].category && entry.DepartmentId === categories[key].departmentId)
                                                            .reduce((acc: number, cur: any) => acc + cur.Quantity, 0).toFixed(2) > 0
                                                            ?
                                                            row[day]?.entries
                                                                .filter((entry: any) => entry.Category === categories[key].category && entry.DepartmentId === categories[key].departmentId)
                                                                .reduce((acc: number, cur: any) => acc + cur.Quantity, 0).toFixed(2)
                                                            :
                                                            "-"
                                                }
                                            </td>
                                        )}
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>
            </div>
        },
        showExpandColumn: true,
        expandColumnRenderer: ({ expanded, rowKey, expandable, }: any) => (
            <i className="material-icons" key={rowKey}>{expanded ? "indeterminate_check_box" : "add_box"}</i>
        ),
        expandHeaderColumnRenderer: ({ isAnyExpands }: any) => (
            <i className="material-icons">{isAnyExpands ? "indeterminate_check_box" : "add_box"}</i>
        ),
        className: "time-admin-nested"
    }

    const parseInputData: any = (data: any) => {
        let csvList: any = [];
        let employeeTable: any = {};
        data.forEach((entry: any) => {
            const { EmployeeId, EmployeeName, EntryDate } = entry;
            const DayOfWeek: string = moment(EntryDate).format("dddd");
            // //console.log("day of week: ", DayOfWeek);
            if (!employeeTable[EmployeeId]) {
                employeeTable[EmployeeId] = {};
                daysOfWeek.forEach((day: string, index: number) => employeeTable[EmployeeId][day] = {
                    entries: [],
                    date: moment(fromToDate.from).add(index, "days")
                });
            }
            employeeTable[EmployeeId]["Employee"] = EmployeeName;
            employeeTable[EmployeeId]["EmployeeId"] = EmployeeId;
            employeeTable[EmployeeId]["Date"] = EntryDate;
            entry.TimeEntryId >= 0 && employeeTable[EmployeeId][DayOfWeek].entries.push(entry);
        });
        let final: any = Object.values(employeeTable);
        //console.log("Parse Input Data: ", Object.values(final));
        final.forEach((entry: any) => {
            let updated: any = { ...entry };
            daysOfWeek.forEach((day: string) => {
                updated[day] = updated[day].entries.reduce((acc: number, e: any) => {
                    //console.log("REduce e: ", e);
                    return acc + e.Quantity
                }, 0);
            });
            csvList.push(updated);
        });
        // Setting CSV Value
        setCSV(final);
        return Object.values(final).sort((entry1: any, entry2: any) => entry1.Employee < entry2.Employee ? -1 : entry1.Employee > entry2.Employee ? 1 : 0);
    }

    const setCSV = (data: any) => {
        let setTo: any = []
        data.forEach((tableRow: any) => {
            const { Sunday, Saturday, Monday, Tuesday, Wednesday, Thursday, Friday } = tableRow;
            //console.log(tableRow);
            const weekData: any = [
                ...Saturday.entries,
                ...Sunday.entries,
                ...Monday.entries,
                ...Tuesday.entries,
                ...Wednesday.entries,
                ...Thursday.entries,
                ...Friday.entries
            ];
            let categories: any = {};
            weekData.forEach((entry: any) => {
                let departmentName: string | undefined = reference.departments.find((dept: DepartmentReferenceType) => dept.DepartmentId === entry.DepartmentId)?.Description;
                if (!departmentName) { departmentName = entry.DepartmentId; }
                if (!categories[entry.Category]) {
                    categories[`${entry.Category} (${entry.DepartmentId})`] = {
                        category: entry.Category,
                        departmentId: entry.DepartmentId,
                        departmentName,
                        fieldTimeCodeId: entry.FieldTimeCodeId
                    };
                }
            });
            const finalData: any = Object.keys(categories).map((key: string) => {
                let f: any = {
                    EmployeeId: tableRow.EmployeeId,
                    EmployeeName: tableRow.Employee,
                    DepartmentId: categories[key].departmentId,
                    DepartmentName: categories[key].departmentName,
                    Category: categories[key].category,
                    Saturday: 0,
                    Sunday: 0,
                    Monday: 0,
                    Tuesday: 0,
                    Wednesday: 0,
                    Thursday: 0,
                    Friday: 0,
                    within: 0,
                    external: 0
                };
                daysOfWeek.forEach((day: string) => {
                    f[day] = tableRow[day]?.entries
                        .filter((e: any) => e.Category === categories[key].category && e.DepartmentId === categories[key].departmentId)
                        .reduce((acc: number, cur: any) => acc + cur.Quantity, 0).toFixed(2)
                });
                f.within = weekData.reduce((acc: number, e: any) =>
                    (e.IsOutOfPC || e.FieldTimeCodeId !== Number(categories[key].fieldTimeCodeId) || e.DepartmentId !== Number(categories[key].departmentId))
                        ? acc
                        : acc + e.Quantity
                    , 0);
                f.external = weekData.reduce((acc: number, e: any) =>
                    (e.IsOutOfPC && e.FieldTimeCodeId === categories[key].fieldTimeCodeId && e.DepartmentId === categories[key].departmentId)
                        ? acc + e.Quantity
                        : acc
                    , 0);
                //console.log("Final Row: ", f);
                return f;
            });
            //console.log("Final Data: ", finalData);
            setTo = [...setTo, ...finalData];
        })
        //console.log("SET TO: ", setTo);
        CSVRef.current = setTo;
    }

    const PCFormatter: any = (cell: any, row: any, rowIndex: number, extraData: any) => {
        const { Saturday, Sunday, Monday, Tuesday, Wednesday, Thursday, Friday } = row;
        let weekEntries: any = [
            ...Saturday.entries,
            ...Sunday.entries,
            ...Monday.entries,
            ...Tuesday.entries,
            ...Wednesday.entries,
            ...Thursday.entries,
            ...Friday.entries
        ];
        let withinTotal: number = weekEntries.reduce((acc: number, entry: any) =>
            entry.IsOutOfPC
                ? acc
                : entry.Category?.includes("Lunch")
                    ? acc
                    : acc + entry.Quantity
            , 0);
        return <span >{withinTotal.toFixed(2)}</span>;
    }

    const OutPCFormatter: any = (cell: any, row: any, rowIndex: number, extraData: any) => {
        const { Saturday, Sunday, Monday, Tuesday, Wednesday, Thursday, Friday } = row;
        let weekEntries: any = [
            ...Saturday.entries,
            ...Sunday.entries,
            ...Monday.entries,
            ...Tuesday.entries,
            ...Wednesday.entries,
            ...Thursday.entries,
            ...Friday.entries
        ];
        let outTotal: number = weekEntries.reduce((acc: number, entry: any) => entry.IsOutOfPC ?
            entry.Category?.includes("Lunch")
                ? acc
                : acc + entry.Quantity
            : acc, 0);
        return <span>{outTotal.toFixed(2)}</span>;
    }

    const footerFormatter = (column: any, colIndex: number, { text }: { text: string }) => {
        const total: number = data.reduce((acc: number, cur: any) => {
            let newTotal: number = acc
            if (cur[column.dataField]) {
                cur[column.dataField]?.entries.forEach((entry: any) => { newTotal += entry.IsOutOfPC ? 0 : entry.Category?.includes("Lunch") ? 0 : entry.Quantity })
            }
            return newTotal;
        }, 0)
        return <div className="d-flex flex-column align-items-center">
            <h6 className="m-0 font-weight-bold">{column.text}</h6>
            <span className="m-0 font-weight-bold text-secondary">{total.toFixed(2)}</span>
        </div>
    }

    const handleCellClick = (e: React.MouseEvent, cellDetails: any, rowIndex: number, colIndex: number) => {
        e.preventDefault();
        // //console.log("Cell Details: ", cellDetails);
        tableRef.current.showDetails(cellDetails);
        let prev: any = document.querySelectorAll(".time-admin-selected");
        if (prev) {
            prev.forEach((el: any) => el.className = "");
        }
        setTimeout(() => {
            const rows = document.querySelectorAll('#time-admin-table tbody:not(.time-admin-nested) tr:not(.time-admin-nested)');
            let filtered: any = Array.prototype.filter.call(rows, (el: any, index: number, rows: any) => {
                return !el.className.includes("time-admin-nested") && !el.firstChild?.className.includes("time-admin-nested");
            });
            filtered[rowIndex]?.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
            //console.log("filtered Rows: ", filtered);
            if (filtered) {
                const cell: any = filtered[rowIndex].querySelector(`:nth-child(${colIndex + 2})`);
                if (cell) { cell.className = "time-admin-selected time-admin-selected-cell"; }
            }
            // const cell: any = document.querySelector(`#time-admin-table tbody :nth-child(${rowIndex + 1}) :nth-child(${colIndex + 2})`);
            // if(cell){ cell.className = "time-admin-selected"; }
            setSelected([rowIndex, colIndex])
        }, 600)
    }

    const handleZeroToggle = (e: React.MouseEvent) => { e.preventDefault(); setShowZeros(!showZeros); }

    const columns: any = [
        {
            dataField: "Employee",
            text: "Employee",
            footer: (column: any, colIndex: number, { text }: { text: string }) => <div style={{ marginTop: 20 }} className="d-flex h-100 text-center justify-content-center align-items-center">
                Total Hours:
            </div>,
            footerClasses: "p-0"
        },
        {
            dataField: "Saturday",
            text: `SAT ${moment(fromToDate.from).format("MM/DD")}`,
            formatter: (cell: any, row: any, rowIndex: number, extraData: any) => cellFormatter(cell, row, rowIndex, extraData, 1),
            formatExtraData: { showZeros, selected },
            footer: "Totals",
            footerFormatter: footerFormatter,
            editCellStyle: (cell: any, row: any, rowIndex: number, colIndex: any) => (selected[0] === rowIndex && selected[1] === colIndex)
                ? { border: "2px solid blue" }
                : {},
            footerClasses: "p-0"
        },
        {
            dataField: "Sunday",
            text: `SUN ${moment(fromToDate.from).add(1, "day").format("MM/DD")}`,
            formatter: (cell: any, row: any, rowIndex: number, extraData: any) => cellFormatter(cell, row, rowIndex, extraData, 2),
            formatExtraData: { showZeros, selected },
            footer: "Totals",
            footerFormatter: footerFormatter,
            editCellClasses: (cell: any, row: any, rowIndex: number, colIndex: any) => (selected[0] === rowIndex && selected[1] === colIndex) ? "border border-primary" : "",
            footerClasses: "p-0"
        },
        {
            dataField: "Monday",
            text: `MON ${moment(fromToDate.from).add(2, "day").format("MM/DD")}`,
            formatter: (cell: any, row: any, rowIndex: number, extraData: any) => cellFormatter(cell, row, rowIndex, extraData, 3),
            formatExtraData: { showZeros, selected },
            footer: "Totals",
            footerFormatter: footerFormatter,
            editCellClasses: (cell: any, row: any, rowIndex: number, colIndex: any) => (selected[0] === rowIndex && selected[1] === colIndex) ? "border border-primary" : "",
            footerClasses: "p-0"
        },
        {
            dataField: "Tuesday",
            text: `TUE ${moment(fromToDate.from).add(3, "day").format("MM/DD")}`,
            formatter: (cell: any, row: any, rowIndex: number, extraData: any) => cellFormatter(cell, row, rowIndex, extraData, 4),
            formatExtraData: { showZeros, selected },
            footer: "Totals",
            footerFormatter: footerFormatter,
            editCellClasses: (cell: any, row: any, rowIndex: number, colIndex: any) => (selected[0] === rowIndex && selected[1] === colIndex) ? "border border-primary" : "",
            footerClasses: "p-0"
        },
        {
            dataField: "Wednesday",
            text: `WED ${moment(fromToDate.from).add(4, "day").format("MM/DD")}`,
            formatter: (cell: any, row: any, rowIndex: number, extraData: any) => cellFormatter(cell, row, rowIndex, extraData, 5),
            formatExtraData: { showZeros, selected },
            footer: "Totals",
            footerFormatter: footerFormatter,
            editCellClasses: (cell: any, row: any, rowIndex: number, colIndex: any) => (selected[0] === rowIndex && selected[1] === colIndex) ? "border border-primary" : "",
            footerClasses: "p-0"
        },
        {
            dataField: "Thursday",
            text: `THU ${moment(fromToDate.from).add(5, "day").format("MM/DD")}`,
            formatter: (cell: any, row: any, rowIndex: number, extraData: any) => cellFormatter(cell, row, rowIndex, extraData, 6),
            formatExtraData: { showZeros, selected },
            footer: "Totals",
            footerFormatter: footerFormatter,
            editCellClasses: (cell: any, row: any, rowIndex: number, colIndex: any) => (selected[0] === rowIndex && selected[1] === colIndex) ? "border border-primary" : "",
            footerClasses: "p-0"
        },
        {
            dataField: "Friday",
            text: `FRI ${moment(fromToDate.to).format("MM/DD")}`,
            formatter: (cell: any, row: any, rowIndex: number, extraData: any) => cellFormatter(cell, row, rowIndex, extraData, 7),
            formatExtraData: { showZeros, selected },
            footer: "Totals",
            footerFormatter: footerFormatter,
            editCellClasses: (cell: any, row: any, rowIndex: number, colIndex: any) => (selected[0] === rowIndex && selected[1] === colIndex) ? "border border-primary" : "",
            footerClasses: "p-0"
        },
        {
            dataField: "dummy1",
            text: "Within",
            formatter: PCFormatter,
            footerClasses: "p-0"
        },
        {
            dataField: "dummy2",
            text: "External",
            formatter: OutPCFormatter,
            footerClasses: "p-0"
        }
    ];

    const findWeekStartEnd = (date: any = null): void => {
        // Will find the Friday and Saturday of supplied date
        let now = date ? moment(date).toDate() : new Date();
        now.setHours(0, 0, 0, 0);
        // Gets closest Saturday to date. if it is a Saturday nothing changes
        let saturday = new Date(now);
        if (!(saturday.getDay() === 6)) { // day is not currently saturday
            let newDate = saturday.getDate() - (saturday.getDay() + 1);
            saturday.setDate(newDate);
        }
        // Adds 7 days to Saturday to get next Friday
        let friday = moment(saturday).add(6, "days");
        // Get an array of date strings with all days in between
        // //console.log("Dates getting passed to get range : ", saturday, friday);
        // let range: Array<string> = getDateRange(saturday, friday, "M/DD/YYYY");
        setFromToDate({ from: moment(saturday).format("MM/DD/YYYY"), to: friday.format("MM/DD/YYYY") })
    }

    const handleWeekSwitch = (e: React.MouseEvent, goForward: boolean = true) => {
        e.preventDefault();
        findWeekStartEnd(goForward ? moment(fromToDate.to).add(1, "day") : moment(fromToDate.from).subtract(1, "day"));
    }

    const getReferenceData = () => {
        if (cancelTokenSource.current?.token) {
            cancelTokenSource.current?.cancel();
        }
        cancelTokenSource.current = axios.CancelToken.source();
        axios.get(process.env.REACT_APP_API_URL + "/api/timeadmin/reference", { ...AxiosConfig.configValue("min"), cancelToken: cancelTokenSource.current?.token })
            .then(res => {
                //console.log("Reference:  ", res);
                AxiosConfig.checkResponse(res);
                const { states, profitCenters, departments } = res.data;
                setReference({ states, profitCenters, departments });
                if (states.length === 1) {
                    setState({ label: states[0].name, value: states[0].id });
                }
                if (profitCenters.length === 1) {
                    setProfitCenter({ label: profitCenters[0].name, value: profitCenters[0].id })
                }

                // Want the users home state and profit center to be selected by default.
                if (props.profitCenterId) {
                    let homeProfitCenter: any;
                    let homeState : any;

                    if (profitCenters.length > 1) {
                        homeProfitCenter = profitCenters.find((pc: any) => pc.id === parseInt(props.profitCenterId));
                    }                   
                    if (homeProfitCenter && states.length > 1) {
                        homeState = states.find((state: any) => state.id === homeProfitCenter.stateId);
                    }

                    if (homeState && homeProfitCenter) {
                        setState({ label: homeState.name, value: homeState.id });
                        setProfitCenter({ label: homeProfitCenter.name, value: homeProfitCenter.id });
                    }                   
                }

                checkForFavorite();
            })
            .catch(err => {
                //console.log(err, err.response);
            })
            .finally(() => {
                cancelTokenSource.current = null;
            })
    }

    const checkForFavorite = () => {
        let filterName: string = query.get("filtername") || "";
        if (filterName) {
            let savedFilter: any = getSavedFilter("Time Administration", filterName || "");
            if (savedFilter) {
                setState(savedFilter.state);
                setProfitCenter(savedFilter.profitCenter);
            }
        }
    }

    const handleStateSelect = (val: any) => {
        setState(val);
        setProfitCenter(null);
    }

    const handleProfitCenterChange = (val: any) => {
        setProfitCenter(val);
    }

    const getTimeData = () => {
        let pcid: any = profitCenter.value || "";
        let fromUnix: number = moment(fromToDate.from).valueOf();
        let toUnix: number = moment(fromToDate.to).valueOf();
        tableRef?.current.toggleLoading(true);
        if (cancelTokenSource.current?.token) {
            cancelTokenSource.current?.cancel();
        }
        cancelTokenSource.current = axios.CancelToken.source();
        axios.get(process.env.REACT_APP_API_URL + `/api/timeadmin/timedata/${pcid}/${fromUnix}/${toUnix}`,
            { ...AxiosConfig.configValue("min"), cancelToken: cancelTokenSource.current?.token })
            .then((res: any) => {
                //console.log("Get Time Data: ", res);
                setData(parseInputData(res.data.timesheets));
                tableRef?.current?.toggleLoading(false);
                tableRef?.current?.triggerFilter();
            })
            .catch((err: any) => {
                //console.log(err, err.response);
                setData([]);
                if (err.message !== undefined) {
                    tableRef?.current?.toggleLoading(false);
                    tableRef?.current?.triggerFilter();
                }
            })
            .finally(() => {
                cancelTokenSource.current = null;
            })
    }

    const refreshEmployee = (employeeId: any, profitCenterId: string) => {
        axios.get(process.env.REACT_APP_API_URL + `/api/timeadmin/employeetimedata/${employeeId}/${profitCenterId}/${moment(fromToDate.from).valueOf()}/${moment(fromToDate.to).valueOf()}`, AxiosConfig.configValue("min"))
            .then((res: any) => {
                //console.log("Refresh Employee Res: ", res);
                if (data) {
                    //console.log("Data to add to: ", data);
                    let copy: Array<{ Date: string, Employee: string, Employeeid: number } | any> = [...data];
                    let foundIndex: number = copy.findIndex((row: any) => row.EmployeeId === employeeId);
                    if (foundIndex >= 0) {
                        const parsed: any = parseInputData(res.data.timesheets)[0];
                        copy.splice(foundIndex, 1, parsed);
                        setData(copy);
                        const currentValue: any = { ...tableRef?.current.getDetails() };
                        //console.log(parsed, moment(currentValue.date).format("dddd"));
                        tableRef.current.showDetails(currentValue ? {
                            ...currentValue,
                            entries: parsed[moment(currentValue.date).format("dddd")].entries || []
                        } : null);
                    }
                }
            })
            .catch((err: any) => {
                //console.log(err, err.response);
            })
    }

    // const saveToFavorites = async () => {
    //     if (state?.value && profitCenter?.value) {
    //         const prompt: any = new Dialog({ message: "Filter Name: ", type: "prompt" });
    //         const answer: any = await prompt.show();
    //         if (answer) {
    //             props.addFavoriteFilter({
    //                 moduleName: "Time Administration",
    //                 favoriteName: answer,
    //                 url: `/hr/time-administration?filtername=${answer}`,
    //                 category: "Time Administration",
    //                 filters: {
    //                     profitCenter: profitCenter,
    //                     state: state
    //                 }
    //             });
    //         }
    //     } else {
    //         const alert: any = new Dialog({ type: "alert", message: "Both state and area are required to save to favorites.", trueText: "Confirm" });
    //         await alert.show();
    //     }
    // }

    //r-18-lint-dj
    // eslint-disable-next-line
    React.useEffect(() => { if (reference) { checkForFavorite() } }, [query.get("filtername"), props.history.length])

    React.useEffect(() => {
        if (profitCenter) {
            getTimeData();
            setInUsePC(profitCenter);
        }
        //r-18-lint-dj
        // eslint-disable-next-line
    }, [profitCenter, fromToDate])

    React.useEffect(() => {
        if (selected[0] === -1 && selected[1] === -1) {
            let prev: any = document.querySelectorAll(".time-admin-selected");
            if (prev) {
                prev.forEach((el: any) => el.className = "");
            }
        }
    }, [selected])

    React.useEffect(() => {
        findWeekStartEnd(Date.now())
        getReferenceData();
        //r-18-lint-dj
        // eslint-disable-next-line
    }, [])

    return (
        <DoublePanel
            keyField="EmployeeId"
            columns={columns}
            data={data}
            manual
            url=""
            ref={tableRef}
            turnIntoModal={false}
            tableProps={{
                expandRow: expandedRow,
                rowEvents: {},
                id: "time-admin-table",
                rowClasses: (row: any, rowIndex: number) => rowIndex === selected[0] ? "time-admin-selected" : ""
            }}
            searchList={["Employee"]}
            secondaryMinSize={40}
            Header={({ onSearchChange, searchValue, setValue }: any) => {
                return <div className="d-flex flex-column align-items-center">
                    <div className="w-100 d-flex flex-row justify-content-between align-items-center">
                        <div className='col-3'>
                            <h5 className='fw-bold'>Time Administration</h5>
                        </div>
                        <div />
                        <div className="center col-5 me-5 pe-5">
                            <i onClick={(e: any) => handleWeekSwitch(e, false)} className="material-icons action-text mr-2 border border-rounded" title="Previous Week">chevron_left</i>
                            <div className="d-flex">
                                <h5 className="mr-1">{fromToDate.from} - {fromToDate.to}</h5>
                                <DatePicker
                                    type="custom"
                                    CustomInput={({ openDatePicker, value }: any) =>
                                        <i onClick={openDatePicker} title={moment(value).format("MM/DD/YYYY")} className="material-icons action-text">edit_calendar</i>}
                                    useCloseCallback
                                    value={fromToDate.from}
                                    onChange={(val: any) => findWeekStartEnd(val.valueOf())}
                                />
                            </div>
                            <i onClick={handleWeekSwitch} className="material-icons action-text ml-2 border border-rounded" title="Next Week">chevron_right</i>
                        </div>
                        <div className='col-1'>
                        </div>
                        <div className='col-2'>
                            {/* <Checkbox
                                label="Add to Favorites"
                                isChecked
                                onChange={saveToFavorites}
                                isCheckedIcon="favorite"
                                notCheckedIcon="favorite"
                                className="align-self-end"
                            /> */}
                        </div>

                    </div>
                    <div style={{ marginLeft: 20 }} className="d-flex flex-row align-items-center justify-content-between w-100">
                        <div onClick={handleZeroToggle} className="d-flex col-2 align-items-center">
                            <div className="d-flex align-items-center action-text">
                                <i className="material-icons">{showZeros ? "check_box" : "check_box_outline_blank"}</i>
                                <span>Display Zeros</span>
                            </div>
                        </div>
                        <Select
                            onChange={handleStateSelect}
                            value={state}
                            className="col-3"
                            options={reference?.states.map((s: any) => ({ label: s.name, value: s.id }))}
                            tabIndex="1"
                        />
                        <Select
                            id="ta-pc-select"
                            isDisabled={!state}
                            className="col-3"
                            options={reference?.profitCenters
                                .filter((pc: any) => state ? state?.value === pc.stateId : false)
                                .map((pc: any) => ({ label: pc.name, value: pc.id }))
                            }
                            onChange={(val: any) => { setValue(""); handleProfitCenterChange(val); }}
                            value={profitCenter}
                            tabIndex="2"
                        />
                        <CSVLink
                            className="action-text d-flex align-items-center justify-content-center px-1"
                            style={{ height: 45, width: 45, marginRight: 20 }}
                            filename={"timeAdmin.csv"}
                            data={CSVRef?.current || []}
                            headers={[
                                { label: "Employee ID", key: "EmployeeId" },
                                { label: "Name", key: "EmployeeName" },
                                { label: "Department ID", key: "DepartmentId" },
                                { label: "Department Name", key: "DepartmentName" },
                                { label: "Time Code", key: "Category" },
                                { label: dayjs(fromToDate.from).format("MM/DD/YYYY"), key: "Saturday" },
                                { label: dayjs(fromToDate.from).add(1, "day").format("MM/DD/YYYY"), key: "Sunday" },
                                { label: dayjs(fromToDate.from).add(2, "day").format("MM/DD/YYYY"), key: "Monday" },
                                { label: dayjs(fromToDate.from).add(3, "day").format("MM/DD/YYYY"), key: "Tuesday" },
                                { label: dayjs(fromToDate.from).add(4, "day").format("MM/DD/YYYY"), key: "Wednesday" },
                                { label: dayjs(fromToDate.from).add(5, "day").format("MM/DD/YYYY"), key: "Thursday" },
                                { label: dayjs(fromToDate.from).add(6, "day").format("MM/DD/YYYY"), key: "Friday" },
                                { label: "Within", key: "within" },
                                { label: "External", key: "external" }
                            ]}
                            target="_blank"
                            title="Download CSV"
                        >
                            <img src={CsvIcon} alt="Csv Icon" style={{ height: "24px" }} />
                        </CSVLink>
                        <SearchInput onChange={onSearchChange} value={searchValue} leftIcon='filter_alt'/>
                    </div>
                </div>
            }}
            DetailPanel={(p: any) => <Details
                reference={reference}
                unselectRow={() => { setSelected([-1, -1]) }}
                profitCenter={inUsePC?.value}
                profitCenterName={inUsePC?.label}
                {...p}
                refresh={refreshEmployee}
            />}
            startVertical
        />
    );
}

const mapStateToProps = (state: AppState) => ({
    profitCenterId: state.user.homeProfitCenter
});

export default connect(mapStateToProps, { addFavoriteFilter })(TimeAdministration);